import { Component, OnInit, HostListener } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'src/app/service/message.service';
import { MessageModel } from 'src/app/models/commission/message.model';
import { NotificationService } from 'src/app/service/notification.service';
import { NotificationType } from 'src/app/enum/notification-type.enum';

@Component({
  selector: 'app-message-center',
  templateUrl: './message-center.component.html',
  styleUrls: ['./message-center.component.css']
})
export class MessageCenterComponent implements OnInit {


  currentPage = 1;
  pageSize = 5;
  pages: number[] = [];
  loginEmployeeId: string;

  public messages: MessageModel[] = [];

  constructor(private http: HttpClient, private messageService: MessageService, private notificationService: NotificationService) { }


  public getNotificationMessages(loginEmployeeId: string): void {
    this.messageService.getMessagesByEmpId(loginEmployeeId).subscribe((response) => {
      console.log('API total:', response.length,
      'unique by notificationId:', new Set(response.map(r => r.notificationId)).size);
      const byId = new Map<string, MessageModel>();
      for (const m of response) {
        if (!byId.has(m.notificationId)) byId.set(m.notificationId, m);
      }
      this.messages = Array.from(byId.values())
        .sort((a, b) => new Date(b.startTime || b.created_dt).getTime()
                       - new Date(a.startTime || a.created_dt).getTime());
    
      const pageCount = Math.ceil(this.messages.length / this.pageSize);
      this.pages = pageCount ? Array.from({ length: pageCount }, (_, i) => i + 1) : [];
      if (this.currentPage > this.pages.length) this.currentPage = this.pages.length || 1;
    });
      (errorResponse: HttpErrorResponse) => {
        const msg: any = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
  }

  ngOnInit() {
    this.loginEmployeeId = localStorage.getItem('CURRENT_EMPLOYEEID_SESSION');
    this.getNotificationMessages(this.loginEmployeeId);
  }


  get pagedMessages() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.messages.slice(start, start + this.pageSize);
  }
  goToPage(p: number) { this.currentPage = p; }
  prevPage() { if (this.currentPage > 1) this.currentPage--; }
  nextPage() { if (this.currentPage < this.pages.length) this.currentPage++; }

  dismissSelected() {
    const selected = this.messages.filter(m => m.selected && !m.dismissed);
  
    if (!selected.length) return;
  
    let completed = 0;
  
    for (const msg of selected) {
      this.messageService.dismissMessage(msg.notificationId, this.loginEmployeeId)
        .subscribe({
          next: () => {
            completed++;
            if (completed === selected.length) {
              this.getNotificationMessages(this.loginEmployeeId);
            }
          },
          error: (errorResponse: HttpErrorResponse) => {
            const msg: any = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          }
        });
    }
  }
  


  selectedMessage: any = null;
  popupPosition = { top: 0, left: 0 };
  isClickInsidePopup = false;

  showFullMessage(msg: any, event: MouseEvent): void {
    this.isClickInsidePopup = true;

    if (this.selectedMessage === msg) {
      this.selectedMessage = null;
      return;
    }

    this.selectedMessage = msg;

    const popupWidth = 400;
    const popupHeight = 300;
    let left = event.clientX;
    let top = event.clientY;

    if (left + popupWidth > window.innerWidth - 10) {
      left = window.innerWidth - popupWidth - 10;
    }
    if (top + popupHeight > window.innerHeight - 10) {
      top = window.innerHeight - popupHeight - 10;
    }

    this.popupPosition = { top, left };
  }


  closePopup(): void {
    this.selectedMessage = null;
  }

  get undismissedCount(): number {
    return this.messages.filter(m => !m.dismissed).length;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.isClickInsidePopup) {
      this.isClickInsidePopup = false;
      return;
    }

    const popup = document.querySelector('.popup-box');
    if (popup && !popup.contains(event.target as Node)) {
      this.selectedMessage = null;
    }
  }

}

